module.exports = __webpack_public_path__ + "nc_static/media/file-pdf.66dcedee.svg";